var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.046875 11 C 24.785156 11.003906 24.535156 11.105469 24.351563 11.289063 L 3.265625 32.203125 C 2.875 32.59375 2.871094 33.226563 3.257813 33.617188 L 9.234375 39.640625 C 9.625 40.035156 10.257813 40.039063 10.648438 39.648438 L 25 25.414063 L 39.234375 39.765625 C 39.625 40.15625 40.257813 40.160156 40.648438 39.769531 L 46.671875 33.796875 C 46.863281 33.609375 46.96875 33.355469 46.96875 33.089844 C 46.972656 32.824219 46.867188 32.570313 46.679688 32.378906 L 25.765625 11.296875 C 25.574219 11.101563 25.316406 10.996094 25.046875 11 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeading);
export default __webpack_public_path__ + "static/media/leading.747052682e8cee358d8879f3da7ca394.svg";
export { ForwardRef as ReactComponent };